var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import PageHeader from "../../components/PageHeader";
import UserListSingle from "../../components/UserListSingle";
import { MenuOption } from "../../components/MenuOption";
import icons from "../../utils/Icons";
import EditProfileModal from "../../components/modals/EditProfileModal";
import AddUnionModal from "../../components/modals/AddUnionModal";
import { logout, updateLocalStorageAttribute, updateUserState } from "../../store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import useChaseListNavigate from "../../hooks/useChaseListNavigate";
import useFetchUserFromList from "../../hooks/useFetchUserFromList";
import useAddUnion from "../../hooks/useAddUnion";
import { toast, ToastContainer } from "react-toastify";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
var Profile = function () {
    var chaseListNavigate = useChaseListNavigate();
    var userList = useSelector(function (state) { return state.userList.list; });
    var userId = useSelector(function (state) { return state.user.userId; });
    var unionNo = useSelector(function (state) { return state.user.unionNo; });
    var _a = useState(false), userExistsInList = _a[0], setUserExistsInList = _a[1];
    var dispatch = useDispatch();
    var _b = useState(false), showEditProfileModal = _b[0], setShowEditProfileModal = _b[1];
    var _c = useState(false), showAddUnionModal = _c[0], setShowAddUnionModal = _c[1];
    var _d = useAddUnion(), addUnion = _d.addUnion, savingUnion = _d.loading;
    var statuses = useSelector(function (state) { return state.statuses.statuses; });
    var existsInList = useFetchUserFromList(userId, userList);
    var editProfileHandle = function (value) {
        setShowEditProfileModal(value);
    };
    var updateProfileHandle = function (error) {
        if (error == null) {
            toast.success('Updated Successfully');
        }
        else {
            toast.error(error);
        }
        setShowEditProfileModal(false);
    };
    var handleLogout = function () {
        dispatch(logout());
        chaseListNavigate('/');
    };
    useEffect(function () {
        if (existsInList) {
            var seniority = existsInList.seniority;
            var seniority_show = '';
            if (seniority < 1) {
                switch (seniority) {
                    case -3:
                        seniority_show = 'SS';
                        break;
                    case -2:
                        seniority_show = "CAS";
                        break;
                    default:
                        seniority_show = "JRY";
                        break;
                }
            }
            else {
                if (seniority >= 1 && seniority <= 5)
                    seniority_show = "".concat(seniority, " \u2022 U");
                if (seniority >= 6 && seniority <= 10)
                    seniority_show = "".concat(seniority, " \u2022 C");
                if (seniority >= 11 && seniority <= 15)
                    seniority_show = "".concat(seniority, " \u2022 B");
                if (seniority >= 16 && seniority <= 20)
                    seniority_show = "".concat(seniority, " \u2022 A");
                if (seniority >= 21 && seniority <= 25)
                    seniority_show = "".concat(seniority, " \u2022 AA");
                if (seniority >= 26)
                    seniority_show = "".concat(seniority, " \u2022 AAA");
            }
            setUserExistsInList({
                name: existsInList.name,
                date: existsInList.date,
                experience: seniority_show,
                status: statuses[existsInList.deleted],
                positions: existsInList.position,
                image: existsInList.imgUrl,
                union_member: existsInList.union_member,
                id: existsInList.id,
                updated_at: existsInList.updated_at
            });
        }
    }, [existsInList]);
    return (_jsxs("div", { children: [_jsx(PageHeader, { pageTitle: "Profile" }), _jsx(ToastContainer, { position: 'top-right' }), _jsxs("div", { className: "flex-1 overflow-y-auto custom-content-height px-[18px] py-[18px] bg-[#F7F7F7]", children: [userExistsInList && _jsx(UserListSingle, __assign({}, userExistsInList)), !unionNo && (_jsx("div", { onClick: function () { return setShowAddUnionModal(true); }, className: "bg-white rounded-[10px] shadow-sm border-l-4 border-[#5898FD] p-[14px] my-[12px] cursor-pointer", children: _jsxs("div", { className: "flex items-start gap-[10px]", children: [_jsx("div", { className: "text-[#5898FD] mt-[2px]", children: _jsx(InfoOutlinedIcon, { style: { fontSize: 20 } }) }), _jsxs("div", { className: "flex-1", children: [_jsx("p", { className: "text-[14px] font-medium text-[#333] m-0", children: "Are you a union member?" }), _jsx("p", { className: "text-[13px] text-[#666] mt-[4px] m-0", children: "Tap here to add your union number." })] })] }) })), _jsx("div", { onClick: function () { return editProfileHandle(true); }, children: _jsx(MenuOption, { icon: icons.editBlue, label: "Edit Profile", hasArrow: true }) }), _jsx(MenuOption, { icon: icons.headphone, label: "Logout", hasArrow: false, onClick: handleLogout })] }), showEditProfileModal === true && (_jsx(EditProfileModal, { closeModal: function () { return editProfileHandle(false); }, saveProfileHandle: updateProfileHandle })), showAddUnionModal && (_jsx(AddUnionModal, { closeModal: function () { return setShowAddUnionModal(false); }, loading: savingUnion, onSubmit: function (extractedUnionNo, cardImage) { return __awaiter(void 0, void 0, void 0, function () {
                    var saved;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, addUnion(extractedUnionNo, cardImage)];
                            case 1:
                                saved = _a.sent();
                                if (saved) {
                                    dispatch(updateUserState({ key: 'unionNo', value: saved }));
                                    updateLocalStorageAttribute('union_no', saved);
                                    toast.success('Union number added');
                                    setShowAddUnionModal(false);
                                }
                                else {
                                    toast.error('Could not save your union number. Please try again.');
                                }
                                return [2 /*return*/];
                        }
                    });
                }); } }))] }));
};
export default Profile;
